import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { routes } from './app-routing.module';

import { ErrorInterceptor } from './interceptors/error.interceptor';
import { NotificationService } from './services/repositories/notification.service';
import { GestionErreursService } from './services/gestion-erreurs.service';

import { HeaderComponent } from './common-parts/header/header.component';
import { MenuComponent } from './common-parts/menu/menu.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

@NgModule({
  imports: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderWrapperModule {}

@NgModule({
  imports: [MenuComponent],
  exports: [MenuComponent]
})
export class MenuWrapperModule {}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HeaderWrapperModule, // wrapper qui importe HeaderComponent
    MenuWrapperModule,   // wrapper qui importe MenuComponent
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    NotificationService,
    GestionErreursService,
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'fr',
      lang: 'fr'
    }),
    { provide: LOCALE_ID, useValue: 'fr' },
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
/*



// app.module.ts
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from "./app.component";
import { routes } from "./app-routing.module";

import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { NotificationService } from "./services/repositories/notification.service";
import { GestionErreursService } from "./services/gestion-erreurs.service";

import { HeaderComponent } from "./common-parts/header/header.component";
import { MenuComponent } from "./common-parts/menu/menu.component";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    MenuComponent,
    HeaderComponent,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    NotificationService,
    GestionErreursService,
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"}),
      fallbackLang: 'fr',
      lang: 'fr'
    }),
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
*/